<template>
  <transition name="fade">
    <div v-if="visible" class="toast-message" :class="type">
      <span>{{ message }}</span>
      <svg-loader :name="svgIconName" class="close-button" @click="close" />
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, watchEffect } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { computed } from 'vue';

/**
 * ToastMessageのprops
 */
interface ToastMessageProps {
  message: string;
  type?: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
}

const props = defineProps<ToastMessageProps>();
const emit = defineEmits<{
  (e: 'close'): void;
}>();

const visible = ref(true);

/**
 * ToastMessageのタイプ
 */
const close = () => {
  visible.value = false;
  emit('close');
};

watchEffect(() => {
  const timeout = setTimeout(() => {
    close();
  }, props.duration || 3000);

  return () => clearTimeout(timeout);
});

const svgIconName = computed(() => {
  switch (props.type) {
    case 'success':
      return 'toastSuccessIcon';
    case 'error':
      return 'toastErrorIcon';
    // successとerrorしか追加してないので必要に応じて追加してください
    default:
      return 'toastSuccessIcon';
  }
});
</script>

<style scoped lang="scss">
.toast-message {
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  gap: 16px;
  border: 1px solid $semanticSuccess;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 0px 22px 0px #80808066;
  padding: 14px 16px;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  transition: opacity 0.3s ease;

  font-family: Noto Sans JP;
  font-size: 14px;
  font-weight: 400;
  line-height: 18.2px;
  text-align: left;

  color: $textSecondary;
}

.toast-message.success {
  border: 2px solid #4caf50;
}

.toast-message.error {
  border: 2px solid #f44336;
}

.toast-message.info {
  border: 2px solid #2196f3;
}

.toast-message.warning {
  border: 2px solid #ff9800;
}

.close-button {
  background: none;
  border: none;
}
</style>
